import { useI18n } from "@/lib/i18n/i18n";
import { STATUSES } from "@/lib/demo/applications";

export const StatusBadge = ({ status, testId }) => {
  const { t } = useI18n();
  const s = STATUSES[status];
  return <span className={`inline-flex whitespace-nowrap rounded-full px-3 py-1 text-[11px] font-bold ${s.cls}`} data-testid={testId}>{t(s.label)}</span>;
};
